import { type RouteRecordRaw } from 'vue-router';

export enum MODULE_ROUTE {
  password = 'SuccessPassword',
  download = 'SuccessDownload',
  login = 'SuccessLogin',
  email = 'SuccessEmail',
  onboardingPassword = 'OnboardingPassword',
  onboardingWelcome = 'OnboardingWelcome',
  onboardingStepPhone = 'OnboardingStepPhone',
  onboardingStepEmail = 'OnboardingStepEmail',
  onboardingStepScan = 'OnboardingStepScan',
  onboardingFinish = 'OnboardingFinish',
  onboardingDisabled = 'OnboardingDisabled',
}

export const routes: RouteRecordRaw[] = [
  {
    path: '/:lang?/success/',
    component: () => import('@/modules/thank-purchase/layout/LayoutPage.vue'),
    redirect: {
      name: MODULE_ROUTE.password,
    },
    children: [
      {
        path: 'password/:productId',
        name: MODULE_ROUTE.password,
        component: () =>
          import('@/modules/thank-purchase/pages/password/PagePassword.vue'),
        meta: {
          i18nAlias: 'thank-purchase',
        },
      },
      {
        path: 'download/:productId',
        name: MODULE_ROUTE.download,
        component: () =>
          import('@/modules/thank-purchase/pages/download/PageDownload.vue'),
        meta: {
          i18nAlias: 'thank-purchase',
        },
      },
      {
        path: 'login/:productId',
        name: MODULE_ROUTE.login,
        component: () =>
          import('@/modules/thank-purchase/pages/login/PageLogin.vue'),
        meta: {
          i18nAlias: 'thank-purchase',
        },
      },
    ],
  },
  {
    path: '/:lang?/success/',
    component: () =>
      import('@/modules/thank-purchase/layout/LayoutEmailPage.vue'),
    children: [
      {
        path: 'email/:productId',
        name: MODULE_ROUTE.email,
        component: () =>
          import('@/modules/thank-purchase/pages/email/PageEmail.vue'),
        meta: {
          i18nAlias: 'thank-purchase',
        },
      },
    ],
  },
  {
    path: '/:lang?/success/',
    component: () =>
      import('@/modules/thank-purchase/layout/LayoutOnboardingPage.vue'),
    children: [
      {
        path: 'onboarding-password/:productId/',
        name: MODULE_ROUTE.onboardingPassword,
        component: () =>
          import('@/modules/thank-purchase/pages/anti-spy-onboarding/PagePassword.vue'),
        meta: {
          i18nAlias: 'thank-purchase',
        },
      },
      {
        path: 'onboarding-welcome/:productId/',
        name: MODULE_ROUTE.onboardingWelcome,
        component: () =>
          import('@/modules/thank-purchase/pages/anti-spy-onboarding/PageWelcome.vue'),
        meta: {
          i18nAlias: 'thank-purchase',
          isShowSkip: true,
        },
      },
      {
        path: 'onboarding-breach-phone/:productId/',
        name: MODULE_ROUTE.onboardingStepPhone,
        component: () =>
          import('@/modules/thank-purchase/pages/anti-spy-onboarding/PagePhone.vue'),
        meta: {
          i18nAlias: 'thank-purchase',
        },
      },
      {
        path: 'onboarding-breach-email/:productId/',
        name: MODULE_ROUTE.onboardingStepEmail,
        component: () =>
          import('@/modules/thank-purchase/pages/anti-spy-onboarding/PageEmail.vue'),
        meta: {
          i18nAlias: 'thank-purchase',
        },
      },
      {
        path: 'onboarding-scan/:productId/',
        name: MODULE_ROUTE.onboardingStepScan,
        component: () =>
          import('@/modules/thank-purchase/pages/anti-spy-onboarding/PageScan.vue'),
        meta: {
          i18nAlias: 'thank-purchase',
        },
      },
      {
        path: 'onboarding-finish/:productId/',
        name: MODULE_ROUTE.onboardingFinish,
        component: () =>
          import('@/modules/thank-purchase/pages/anti-spy-onboarding/PageFinish.vue'),
        meta: {
          i18nAlias: 'thank-purchase',
        },
      },
      {
        path: 'onboarding-disabled/:productId/',
        name: MODULE_ROUTE.onboardingDisabled,
        component: () =>
          import('@/modules/thank-purchase/pages/anti-spy-onboarding/PageDisabled.vue'),
        meta: {
          i18nAlias: 'thank-purchase',
        },
      },
    ],
  },
];
